import { Component, Inject, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { VendorService } from '../../../../services/vendor.service';
import { Vendor } from '../../../../models/vendor.model';
import { User } from '../../../../models/user.model';
import { UserProfile } from '../../../../models/user-profile.model';
import { UserService } from '../../../../services/user.service';
import { forkJoin, Observable } from 'rxjs';
import { whitespaceValidator } from '../../../../validators/whitespace.validator';
import { UserProfileService } from '../../../../services/user-profile.service';

@Component({
  selector: 'app-edit-vendor-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSlideToggleModule,
    MatProgressBarModule,
    CommonModule,
  ],
  templateUrl: './edit-vendor-dialog.component.html',
  styleUrl: './edit-vendor-dialog.component.scss',
})
export class EditVendorDialogComponent implements OnInit {
  loading: boolean = false;
  checked: boolean = false;

  editVendorForm = new FormGroup({
    id: new FormControl(''),
    name: new FormControl('', [Validators.required, whitespaceValidator]),
    email: new FormControl('', [whitespaceValidator]),
    firstName: new FormControl('', [whitespaceValidator]),
    lastName: new FormControl('', [whitespaceValidator]),
    status: new FormControl('', [whitespaceValidator]),
    phone: new FormControl('', [whitespaceValidator]),
    studentAmbassador: new FormControl('', [whitespaceValidator]),
  });

  vendorToEdit?: Vendor;

  constructor(
    private dialogRef: MatDialogRef<EditVendorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { vendorIdToEdit: string },
    private vendorService: VendorService,
    private userService: UserService,
    private userProfileService: UserProfileService
  ) {}

  getVendor(id: string) {
    this.vendorService.getSingle(id).subscribe((vendor) => {
      this.vendorToEdit = vendor;

      this.editVendorForm.controls.id.setValue(vendor.id ?? '');
      this.editVendorForm.controls.name.setValue(vendor.name);

      this.editVendorForm.controls.email.setValue(vendor.user?.email ?? '');
      this.editVendorForm.controls.status.setValue(vendor.user?.status ?? '');
      this.editVendorForm.controls.firstName.setValue(
        vendor.user?.firstName ?? ''
      );
      this.editVendorForm.controls.lastName.setValue(
        vendor.user?.lastName ?? ''
      );
      this.editVendorForm.controls.phone.setValue(
        vendor.user?.userProfile?.phone ?? ''
      );
      this.editVendorForm.controls.studentAmbassador.setValue(
        vendor.studentAmbassador ?? ''
      );

      if (vendor.status == 'ACTIVE') {
        this.checked = true;
      } else {
        this.checked = false;
      }
    });
  }

  ngOnInit(): void {
    this.getVendor(this.data.vendorIdToEdit);
  }

  onSubmit() {
    var requests: Observable<any>[] = [];
    this.loading = true;

    if (this.checked) {
      this.editVendorForm.controls.status.setValue('ACTIVE');
    } else {
      this.editVendorForm.controls.status.setValue('INACTIVE');
    }

    const vendorBody: Vendor = {
      id: this.editVendorForm.controls.id.value,
      name: this.editVendorForm.controls.name.value,
      studentAmbassador: this.editVendorForm.controls.studentAmbassador.value,
      status: this.editVendorForm.controls.status.value,
    } as Vendor;

    const userBody: User = {
      id: this.vendorToEdit?.user?.id ?? '',
      firstName: this.editVendorForm.controls.firstName.value,
      lastName: this.editVendorForm.controls.lastName.value,
      email: this.editVendorForm.controls.email.value,
    } as User;

    const UserProfileBody: UserProfile = {
      id: this.vendorToEdit?.user?.userProfile?.id ?? '',
      phone: this.editVendorForm.controls.phone.value,
    } as UserProfile;

    requests.push(this.vendorService.update(vendorBody));
    if (userBody.id != null && userBody.id.trim() != '') {
      requests.push(this.userService.update(userBody));
    }

    if (UserProfileBody.id != null && UserProfileBody.id.trim() != '') {
      requests.push(this.userProfileService.update(UserProfileBody));
    }

    forkJoin(requests).subscribe({
      next: () => {
        this.loading = false;
        this.dialogRef.close();
      },
      error: () => {
        this.dialogRef.close({
          message: 'An error has occurred. Please try again.',
        });
      },
    });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
